

const Service = {
    formatDate: function(d) {
		var d = new Date(d);
		Number.prototype.padLeft = function(base,chr){
		var  len = (String(base || 10).length - String(this).length)+1;
		return len > 0? new Array(len).join(chr || '0')+this : this;
	}
		var dformat = [
				   d.getDate().padLeft(),
				   (d.getMonth()+1).padLeft(),
				   d.getFullYear()].join('/') +' ' +
				  [d.getHours().padLeft(),
				   d.getMinutes().padLeft()].join(':');
		return dformat;

    },
	checkIfNull(val){
		if(val!==null){
			return false;
		}
		return true;
	}
};
		
export default Service;